import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import NativeComponent from "../NativeComponent";
import * as nativeComponentListener from "../../../../api/nativeComponentListener";
import {broadcast} from "../../../../api";
import App from "../../../App"
import Message from "../../../FrameMessage/index"
import {getFilePathByRemoteUrl} from "../../../../common/util";


const nativeComponentAbility = NativeComponent.nativeComponentAbility

const [
    _onWebviewLoadPromise,
    _executeLoadPromise,
    _loadRequestFailureListener
] = [
    Symbol('_onWebviewLoadPromise'),
    Symbol('_executeLoadPromise'),
    Symbol('_loadRequestFailureListener')
]

/**
 * @constructor
 * @param options {Object} 构造参数对象
 */
class Webview extends VisibleComponent {
    constructor (options) {
        const action = nativeComponentAPI.createWebview
        super(action, {
            ...options,
            params: options
        })

        this[_onWebviewLoadPromise] = new Promise((resolve, reject)=>{
            console.log('this[_onWebviewLoadPromise]')
            // nativeComponentListener.onWebviewLoad(this.getId(), (data)=>{
            //     console.log('this[_onWebviewLoadPromise] ===>', data)
            //     const { result, error } = data
            //     if(result ===1) {
            //         resolve(result)
            //     }else{
            //         reject(error)
            //     }
            // })

            this.onLoad((data)=>{
                console.log('+++this[_onWebviewLoadPromise] ===>', data)
                const { result, error } = data
                if(result ===1) {
                    resolve(result)
                }else{
                    reject(result)
                }
            })
        })

        this[_loadRequestFailureListener] = []
        this.bindWebviewEvent()
    }

    bindWebviewEvent() {
        this.onLoad((data)=>{
            console.log(`Webview id:${this.getId()} onLoad `, data)
        })
    }

    test1(){
        return new Promise(resolve => {
            resolve()
        })
    }

    @nativeComponentAbility
    test2(){
        return new Promise(resolve => {
            resolve()
        })
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    nativeLoad(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.webviewLoad(_params)
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    load(params) {
        const _params = this.getInvokeParams(params)
        this[_executeLoadPromise] = nativeComponentAPI.webviewLoad(_params)
        this[_executeLoadPromise].then(ret=>{
            const { code } = ret
            if(code!==0 && code!=='0'){
                this._onLoadRequestFailure(ret)
            }
        }).catch((e)=>{
            this._onLoadRequestFailure(e)
        })

        return this[_executeLoadPromise]
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    loadCampaigns(campaigns) {
        const _params = this.getInvokeParams({campaigns})
        return nativeComponentAPI.webviewLoad(_params)
    }

    /**
     * 重新加载
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    reload(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.webviewReload(_params)
    }

    /**
     * 回退
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    goBack(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.webviewGoBack(_params)
    }

    /**
     * 前进
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    goForward(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.webviewGoForward(_params)
    }

    /**
     * 向webview内部的js逻辑发送信息
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    postMessage(params) {
        const _params = {
            id: this.id,
            data: {
                ...params
            }
        }
        return broadcast('webviewPostMessage', _params)
    }

    /**
     * 触发webview内部的js事件
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    fireJsEvent(eventName, eventData) {
        let params = {
            eventName,
            eventData
        }
        const _params = this.getInvokeParams(params)
        console.log('触发webview内部的js事件', _params)
        return nativeComponentAPI.webviewFireEvent(_params)
    }


        //*****************************************--事件--******************************************//

    /**
     * 将当前加载资源成功后触发（回调函数形式）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onLoad(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onWebviewLoad(this.getId(), cb)
    }

    /**
     * 将当前加载资源成功后触发（promise形式）
     * @returns {*|Promise<any>}
     */
    whenLoad(){
        return this[_onWebviewLoadPromise]
    }

    _onLoadRequestFailure(cb) {
        const err = cb
        if(typeof err === 'object' || !cb){
            this[_loadRequestFailureListener].forEach(listener=>{
                listener(err)
            })
        } else {
            'function' === typeof cb && this[_loadRequestFailureListener].push(cb)
        }

    }

    /**
     * webview加载campaign成功时触发
     * 有以下几种情况会认为campaign加载失败
     * 1、被加载的campaign中，js发送广播告知上层自身加载失败
     * 2、调用webview.load加载campaign的请求响应失败（code码不为0）
     * 3、调用webview.load的请求发送成功，但是sdk在之后触发的webview.onWebviewLoad事件中告知加载失败（code码不为0）
     *
     * 以下情况认为campaign加载成功
     * 1、被加载的campaign中，js发送广播告知上层自身加载成功
     *
     * @returns {Promise<any>}
     */
    whenCampaignReady(){
        console.log('whenCampaignReady ============>',App)
        const promise = new Promise((resolve, reject)=>{
            Message.onSubViewEmitMessage('templateLoadFinish', (data)=>{
                console.log('whenCampaignReady.templateLoadFinish ============>',data, data.id, this.id)
                if(data.id === this.id){
                    resolve()
                }
            })
            Message.onSubViewEmitMessage('templateLoadFailure', (data)=>{
                console.log('whenCampaignReady.templateLoadFailure ============>',data, data.id, this.id)
                if(data.id === this.id){
                    reject({
                        msg:'webview 加载campaign失败',
                        data
                    })
                }
            })

            this._onLoadRequestFailure((e)=>{
                // load方法调用后响应异常（code码不为0）
                reject({
                    msg:'调用webview.load响应异常',
                    data: e
                })
            })

            // 如果sdk触发onWebviewLoad事件中响应异常，（result码不为1），reject
            this[_onWebviewLoadPromise].then(ret=>{
                console.log('webview onWebviewLoad ======>', ret)
            }).catch((e)=>{
                console.log('webview onWebviewLoad error ======>', e)
                reject({
                    msg: 'webview.onWebviewLoad sdk触发onWebviewLoad事件中响应异常',
                    data: e
                })
            })
        })

        promise.catch((err)=>{
            console.log(err)
        })
        return promise
    }

    getLoadCampaignParams(url = '', campaigns, unitId, unitSetting, rect){
        return Webview.getLoadCampaignParams(url, campaigns, unitId, unitSetting, rect)
    }

    static async getLoadCampaignParams(url = '', campaigns, unitId, unitSetting, rect) {
        let content = { campaigns, unitId, unitSetting }
        console.log('正在获取load campaign参数：', content,url,  location.href)
        if(url.indexOf('.zip')!==-1){
            let res = await getFilePathByRemoteUrl(url, unitId)
            content.filePath = res.path
        }else if(url.indexOf('.html')!==-1){
            content.fileURL = url
        }
        content.refreshCache = 1
        return {
            content
        }
    }

}

export default Webview
